module.exports = __webpack_public_path__ + "img/c1.4a839b11.jpg";